import React from 'react'
import {
	ShippingList,
	Shipping,
	Checkbox,
	Title,
	Description,
	Logo,
	Info,
} from './style'
import { Icon } from 'components/Icon'

export const ShippingLoader = ({ quantity = 20 }) => {
	return (
		<ShippingList>
			{Array(quantity)
				.fill('')
				.map((i, idx) => (
					<Shipping key={idx}>
						<div>
							<Checkbox />
						</div>
						<div className='flex-grow-1'>
							<Title />
							<Description />
							<Description />
						</div>
						<div>
							<Logo />
						</div>
						<div>
							<Info as={Icon} component='infoTooltip' />
						</div>
					</Shipping>
				))}
		</ShippingList>
	)
}
